module.exports = __webpack_public_path__ + "img/Group-Four.bec81178.svg";